<template>
  <div class="wrapper">
    <div class="title">Call Outcomes</div>
    <div id="chart"></div>
  </div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
import am4themes_material from "@amcharts/amcharts4/themes/material";
export default {
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      chartData: [],
    };
  },
  methods: {
    GenerateChart: async function () {
      am4core.useTheme(am4themes_material);
      let chart = am4core.create("chart", am4charts.PieChart);
      chart.legend = new am4charts.Legend();
      const today = this.stats[Object.keys(this.stats)[Object.keys(this.stats).length - 1]];
      let outcomes = {};
      for (const [date, timeData] of Object.entries(today)) {
        for (const [customerId, customerData] of Object.entries(timeData)) {
          for (const [outcome, value] of Object.entries(customerData)) {
            if (outcome.toLowerCase() == "bookablesessions") continue;
            if (value != undefined) {
              if (!outcomes[outcome]) {
                outcomes[outcome] = 0;
              }
              outcomes[outcome] += value;
            }
          }
        }
      }
      for (const [outcome, value] of Object.entries(outcomes)) {
        this.chartData.push({ outcome: outcome, count: value });
      }
      chart.data = this.chartData;
      chart.innerRadius = am4core.percent(50);

      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "count";
      pieSeries.dataFields.category = "outcome";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 2;
      pieSeries.slices.template.strokeOpacity = 1;
    },
  },
  mounted() {
    this.GenerateChart();
  },
};
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 20fr;
  max-height: 660px;
}

.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
}
</style>
